import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { AbMonitorPageInitialData } from "./abMonitorPageInitialData";

export const abMonitorPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.abMonitor(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<AbMonitorPageInitialData>>("/page-data/abmonitor"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
